import React from 'react';

interface LeftRightProps {
  left: string;
  right: React.ReactNode;
  className?: string;
}

const LeftRight: React.FC<LeftRightProps> = ({ left, right, className }) => {
  return (
    <div className={`flex items-center bg-gray-100 border px-2 py-3 text-gray-600 font-semibold rounded-md justify-between w-full ${className ?? ''}`}>
      <span className="text-sm">{left}</span>
      <div>{right}</div>
    </div>
  );
};

export default LeftRight; 